export const STORAGE_KEYS = {
  REDIRECT_AFTER_AUTH: 'raskmote_redirect_after_auth',
};
